import React from "react";

interface FieldProps {
  id: string;
  label: string;
  error?: string;
  children: React.ReactNode;
}

const Field: React.FC<FieldProps> = ({ id, label, error, children }) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="text-xs font-semibold text-slate-600">
      {label}
    </label>
    {children}
    {error && (
      <span className="flex items-center gap-1 text-[11px] text-rose-500 font-medium">
        ⚠ {error}
      </span>
    )}
  </div>
);

export default Field;